import { type SVGProps } from 'react';
import { type IconProps } from './types';

/** Storefront, the generic icon for an in-store fulfillment method (TEAM-15026). */
export const StorefrontIcon = ({
  title,
  width,
  height,
  ...otherProps
}: Partial<IconProps> & SVGProps<SVGSVGElement>) => (
  <svg
    {...otherProps}
    width={width ?? '16'}
    height={height ?? '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title ?? 'Storefront Icon'}</title>
    <path
      d="M2.5 6.5V13.5H13.5V6.5"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.5L3 2.5H13L14 6.5H2Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path d="M6.5 13.5V10H9.5V13.5" stroke="currentColor" strokeWidth="1" strokeLinejoin="round" />
  </svg>
);
